import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: `${process.env.REACT_APP_API_KEY}`,
  authDomain: `${process.env.REACT_APP_AUTH_DOMAIN}`,
  projectId: 'todo2023-66b6f',
  storageBucket: 'todo2023-66b6f.appspot.com',
  messagingSenderId: '770002544070',
  appId: '1:770002544070:web:f2807eae3458645b583ec7',
};

if (!firebase.apps.length) {
firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

const auth = firebase.auth();
const db = firebase.firestore();

export { db, auth, firebase as default };


